import {Component, ElementRef, Inject, inject, Input, ViewChild} from '@angular/core';
import {FormGroup, ReactiveFormsModule, UntypedFormBuilder, Validators} from "@angular/forms";
import {MetricsService} from "../../services/metrics.service";
import {AppConfigService} from "../../app-config.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-feedback',
    imports: [
        NgIf,
        ReactiveFormsModule
    ],
    templateUrl: './feedback.component.html',
    standalone: true,
    styleUrl: './feedback.component.scss'
})
export class FeedbackComponent {

    private modalService: NgbModal = inject(NgbModal);
    private window: Window;

    @Input()
    public component: string = "";

    constructor(
        private appConfig: AppConfigService,
        private metricService: MetricsService,
        private fb: UntypedFormBuilder,
        @Inject('Window') window: Window
    ) {
        this.window = window;
    }
    /**
     * FEEDBACK FUNCTIONS
     */
    public get isSearchFeedbackEnabled(): boolean {
        return this.appConfig.isSearchFeedbackEnabled();
    }
    public feedbackForm: FormGroup = this.fb.group({
        feedback: [ "", Validators.required ]
    });
    public feedbackFormStatus: string = ""; // sending || success || failed || modalFailed || submitted
    @ViewChild('content') private content: ElementRef | null = null;
    public feedback_thanks( value: string ) {
        let me = this;
        this.metricService.sendFeedback( value );
        this.feedbackForm.reset();
        this.feedbackForm.enable();
        this.feedbackFormStatus = "";
        if ( value == 'not_helpful' ) {
            let modal = this.modalService.open(this.content, { size: 'lg', fullscreen: 'md' });
            modal.closed.subscribe({
                complete: () => {
                    me.resetForm();
                }
            });
        } else {
            this.feedbackFormStatus = "submitted";
            setTimeout( ()=>{ me.resetForm(); }, 3000);
        }
    }
    public submit_feedback() {
        let me = this;
        if ( me.feedbackForm.valid && !me.feedbackForm.disabled ) {
            me.feedbackFormStatus = "sending";
            let feedback_text = me.feedbackForm.get("feedback").value;
            var referrer = document.referrer != '' ? document.referrer : "unknown";
            me.feedbackForm.disable();
            let body = {
                feedback: feedback_text,
                page: me.window.location.href,
                referrer: "paws",
                sitename: me.component, //"portal-search",
                owner: "gdc224",
                timestamp: Date.now()
            };
            fetch(this.appConfig.getFeedbackPostURL(), {
                method: "POST",
                referrer: document.referrer != '' ? document.referrer : "unknown",
                body: JSON.stringify(body),
                headers: {
                    "Content-type": "application/x-www-form-urlencoded",
                }
            })
                .finally(() => {
                    me.feedbackForm.reset();
                    me.feedbackFormStatus = "success";
                    setTimeout(() => {
                        me.resetForm();
                    }, 3000);
                });
        }
    }
    private resetForm() {
        this.feedbackForm.reset();
        this.feedbackFormStatus = "";
        this.modalService.dismissAll();
    }

}
